import styled from 'styled-components';
import Colors from 'theme/Colors';

export const ErrorWrapper = styled.div`
  width: 100%;
  ${(props) => (props.fullPage ? 'min-height: 100vh;' : 'height: 100%;')}
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Lato;
  text-align: center;
  color: ${Colors.navy};

  p {
    margin: 0 0 20px;
    font-size: 18px;
  }
`;
